var PaymentHistoryType;
(function(PaymentHistoryType2) {
  PaymentHistoryType2["WITHDRAWAL"] = "withdrawals";
  PaymentHistoryType2["DEPOSIT"] = "deposits";
})(PaymentHistoryType || (PaymentHistoryType = {}));

export { PaymentHistoryType };
